<template>
  <article class="col-md-6 col-sm-12 card">
    <div class="content">
      <!--:style="'background-image: url(' +image+ ');'"-->
      <link-to :to="link" class="image" >
        <img :src="image" class="size-2">

        <div class="more upper" v-if="clickable !== false">Подробнее</div>
      </link-to>
      <link-to class="title" :to="link" v-if="clickable">
        <h2 v-html="title"></h2>
      </link-to>
      <div class="title-nohover" v-if="!clickable">
        <h2 v-html="title"></h2>
      </div>
    </div>
  </article>
</template>

<script>
  import NewsItemMixin from '../mixins/NewItemMixin.js'

  export default {
    mixins: [NewsItemMixin],
    computed: {
      linkUrl() {
        return '/news/' + this.id;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .card {
     margin-bottom: 50px;
     .content {
        .image {
           display: inline-block;
           padding-bottom: 70%;
            width: 100%;
            position: relative;
            overflow: hidden;
            img {
                transform: scale(1);
                display: block;
                position: absolute;
                @include position-full();
                transition: transform .9s
            }
          .more {
            visibility: hidden;
            display: flex;display: -ms-flexbox;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            @include ease();

           // transform: scale(0.5) rotateZ(180deg);
            color:$color-white;
            @include position-full();
            z-index: 100;
            background-color: rgba($color-blue-2,0.5);
            opacity: 0;
           }
        }

       .title {
         color: $color-black;
         padding-top: 24px;
         display: inline-block;
         text-decoration: none;
         border-bottom: 1px solid #fff;
         h2 {
           padding: 0 0 2px;
           font-size: 31px;
           @media (max-width: $media_sm) {
             font-size: 24px;
           }
         }
       }

       &:hover{
         .image {
            img {
                transform: scale(1.1);
            }
          }
         .more {
           visibility: visible;
           opacity: 1;

          // transform: scale(1) rotateZ(0deg);
         }
         .title {
           border-bottom-color: $color-black-1;
         }
       }
     }
  }
</style>



// WEBPACK FOOTER //
// components/shared/cards/CardProductSmall.vue